export const portfolioFReportLocation = "/foreign/portfolio"